enum EmployeeSecurity {
  viewOnly = 0,
  userProfile = 1,
}

export default EmployeeSecurity;
